<template>
  <section class="exam-subject">
    <h3 class="title">2024年二级建造师<b>考试科目</b>「自助查询」</h3>
    <div class="line"></div>
    <div class="content">
      <table cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <th colspan="2">考试科目</th>
            <th>考试时间</th>
            <th>题型分值</th>
          </tr>
          <tr>
            <td rowspan="2">公共科目</td>
            <td>《建设工程施工管理》</td>
            <td>5月25日 9:00-12:00</td>
            <td>
              <span>
                单选题：60道 1分/道<br />
                多选题：20道 2分/道<br />
                总分：100分
              </span>
            </td>
          </tr>
          <tr>
            <td>《建设工程法规及相关知识》</td>
            <td>5月25日 14:00-16:00</td>
            <td>
              <span>
                单选题：70道 1分/道<br />
                多选题：25道 2分/道<br />
                总分：120分
              </span>
            </td>
          </tr>
          <tr>
            <td rowspan="6">
              专业工程管理<br />
              与实务
            </td>
            <td>建筑工程</td>
            <td rowspan="6">5月26日 9:00-12:00</td>
            <td rowspan="6">
              <span>
                单选题：20道 1分/道<br />
                多选题：10道 2分/道<br />
                案例题：4道 占80分<br />
                总分：120分<br />
                其中案例题80分
              </span>
            </td>
          </tr>
          <tr>
            <td>公路工程</td>
          </tr>
          <tr>
            <td>水利水电工程</td>
          </tr>
          <tr>
            <td>矿业工程</td>
          </tr>
          <tr>
            <td>机电工程</td>
          </tr>
          <tr>
            <td>市政公用工程</td>
          </tr>
        </tbody>
      </table>
      <div class="action">
        <a href="javascript:void(0);" @click="$refs.registerRef.open()"><img src="@/assets/erjian/print_icon.png" />各省准考证打印时间</a>
        <a href="javascript:void(0);" @click="$refs.registerRef.open()"><img src="@/assets/erjian/download_icon.png" />历年必考-考点下载</a>
      </div>
    </div>
    <register-dialog ref="registerRef"></register-dialog>
  </section>
</template>
<script>
import RegisterDialog from './register-dialog.vue'
export default {
  data() {
    return {}
  },
  components: {
    RegisterDialog
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.exam-subject {
  .title {
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    margin: 25px 0 15px;
    color: rgb(17, 67, 135);
    b {
      color: #d51719;
    }
  }
  .line {
    width: 740px;
    margin: 0 auto 30px;
    border-bottom: 1px solid rgb(231, 231, 231);
  }
  .content {
    width: 842px;
    margin: 0 auto;
    table {
      width: 100%;
      tbody {
        tr {
          th {
            font-size: 18px;
            color: #ffffff;
            background-color: #0f509a;
            text-align: center;
            line-height: 60px;
            border: 1px solid #dcdcdc;
          }
          td {
            border: 1px solid #dcdcdc;
            text-align: center;
            line-height: 48px;
            font-size: 18px;
            color: #333333;
          }
        }
      }
    }
  }

  .action {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 40px;
    a {
      width: 410px;
      line-height: 50px;
      height: 50px;
      text-align: center;
      background-color: #0f509a;
      display: block;
      color: #fff;
      opacity: 0.9;
      img {
        margin-right: 10px;
        vertical-align: middle;
      }
      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
